<template>
    <a-drawer title="对接方列表" :visible="visible" :wrap-class-name="drawerWrapClassName" destroy-on-close
              :mask-closable="false" @close="onClose" width="65%">
        <div class="ant-drawer-main">
            <a-table
                :columns="columns"
                :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
                :pagination="pagination"
                :data-source="dataSource"
                :loading="loading"
                @change="onTableChange">
                <template #abutmentType="{text}">
                    <a-tag>
                        <dict-render :dict-obj="dictObjs['abutment_type']" :text="text"></dict-render>
                    </a-tag>
                </template>
                <template #needStatus="{text}">
                    <a-tag>
                        <dict-render :dict-obj="dictObjs['need_status']" :text="text"></dict-render>
                    </a-tag>
                </template>
                <template #action="{record}">
                    <div class="table-row-operations">
                        <span v-if="record.needStatus==1" >对接完成</span>
                        <a v-if="record.needStatus==2" >对接取消</a>
                        <a v-if="record.needStatus==0" @click="onButt(record)">对接</a>
                    </div>
                </template>
            </a-table>
        </div>
    </a-drawer>
</template>
<script>
    import {formMixin, dictMixin, tableListMixin} from "@/mixins";
    import {demandApi} from "@/api/innovationService";
    import DictRender from "@/components/other/DictRender";

    const columns = [
        // {title: "#", dataIndex: "index", key: "index", slots: {customRender: "index"}},
        {title: "对接方名称", dataIndex: "abutmentName", key: "abutmentName"},
        {title: "对接方类型", dataIndex: "abutmentType", key: "abutmentType", slots: {customRender: "abutmentType"}},
        {title: "对接状态", dataIndex: "needStatus", key: "needStatus", slots: {customRender: "needStatus"}},
        {title: "联系电话", dataIndex: "abutmentPhone", key: "abutmentPhone"},
        {title: "操作", dataIndex: "action", key: "action", slots: {customRender: "action"}},
    ];

    export default {
        name: "CompanyAbutmentListModal",
        mixins: [formMixin, dictMixin, tableListMixin],
        components: {DictRender},
        props: {jointId: String},
        data() {
            return {
                dictNames: 'need_status,abutment_type',
                columns,
                queryParamFixed: {
                },
                listUrl: demandApi.abutmentList,
                listKeyField: "id",
            }
        },
        watch: {
            jointId() {
                this.queryParam.needId=this.jointId
                this.loadData(1)
            }
        },

        methods: {
            onButt(record) {
                this.postAction({
                    url: demandApi.affirm,
                    params: {
                        id: record.id,
                    }
                }).then(res => {
                    console.log(res, 'res')
                    this.$notification.success({
                                message: '对接成功',
                                style: {
                                    fontWeight: '600',
                                },
                            });
                            this.loadData()
                })
            },
            onClose() {
                this.visible = false
                this.$emit("onCloseModel")
            }
        }
    }
</script>
